import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';
import { Plate } from '../models/plate';
import { BeadChip } from '../models/bead-chip';
import { MultiBeadChipUpdate } from './multibeadchip-update-dto';

@Injectable({
  providedIn: 'root'
})
export class BeadchipService {

  PLATE_PREPARATION_API = environment.BB_SAMPLE_PROCESSING_API

  constructor(private httpClient: HttpClient) { }

}
